import { useRouter } from "lib/router";
import { useState, useCallback } from "react";
import type { PageScrollValues } from "tracking";
import {
  useSegment,
  useOnPageChange,
  useScrollPercentage,
  PAGE_SCROLL_PAGE_WHITELIST,
  TRACK_SCROLL_PERCENTAGES
} from "tracking";

export const PageScrollTracker: React.FC = () => {
  const { track } = useSegment();

  const { asPath } = useRouter();

  const isWhitelistedPage = (pathname?: string): boolean => {
    if (!pathname) return false;
    const isWhiteListed = PAGE_SCROLL_PAGE_WHITELIST.some((path) =>
      pathname.startsWith(path)
    );
    return isWhiteListed || pathname === "/";
  };

  const [scrollPercentage, setScrollPercentage] = useState<PageScrollValues>(0);

  useScrollPercentage(TRACK_SCROLL_PERCENTAGES, ({ scrollY }) => {
    if (
      !TRACK_SCROLL_PERCENTAGES.includes(scrollY) ||
      scrollY < scrollPercentage
    )
      return;
    setScrollPercentage(scrollY);
  });

  const trackPageScroll = useCallback(() => {
    if (isWhitelistedPage(asPath)) {
      track({
        event: "Page Scroll",
        properties: {
          scroll_percentage: scrollPercentage
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPercentage]);

  useOnPageChange(trackPageScroll);
  return null;
};
